import React from 'react';

const Settings: React.FC = () => {
  return (<div>Settings</div>);
};

export default Settings;
